'use client';

import { Box, Skeleton } from '@mui/material';
import { StyledCard, ImageWrapper, CardContent, CardHead, CardAddress } from './styled';
import { StatsWrapper, StatItem } from '@/components/shared/HousingCardStats/styled';

export const HousingCardSkeleton = () => (
  <StyledCard variant="outlined">
    <ImageWrapper $borderless>
      <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
    </ImageWrapper>
    <CardContent>
      <CardHead>
        <Skeleton
          variant="text"
          width="80%"
          sx={{ fontSize: '16px', lineHeight: 1.26 }}
          animation="wave"
        />
        <CardAddress>
          <Skeleton
            variant="rectangular"
            width={14}
            height={12}
            animation="wave"
            sx={{ borderRadius: '2px', flexShrink: 0 }}
          />
          <Skeleton
            variant="text"
            width="40%"
            sx={{ fontSize: '13px', lineHeight: 1 }}
            animation="wave"
          />
        </CardAddress>
      </CardHead>

      <StatsWrapper>
        {/* Preis — col 1 */}
        <StatItem>
          <Skeleton variant="text" width="55%" sx={{ fontSize: '12px' }} animation="wave" />
          <Skeleton
            variant="text"
            width="75%"
            sx={{ fontSize: '16px', lineHeight: 1.26 }}
            animation="wave"
          />
        </StatItem>
        {/* Fläche — col 2 */}
        <StatItem>
          <Skeleton variant="text" width="60%" sx={{ fontSize: '12px' }} animation="wave" />
          <Skeleton
            variant="text"
            width="70%"
            sx={{ fontSize: '16px', lineHeight: 1.26 }}
            animation="wave"
          />
        </StatItem>
        {/* Zimmer — full row */}
        <StatItem $break>
          <Skeleton variant="text" width="30%" sx={{ fontSize: '12px' }} animation="wave" />
          <Skeleton
            variant="text"
            width="20%"
            sx={{ fontSize: '16px', lineHeight: 1.26 }}
            animation="wave"
          />
        </StatItem>
      </StatsWrapper>

      {/* Broker row — mt: 4px matches QuickRequestModal Container margin-top */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mt: '4px' }}>
        <Skeleton
          variant="rounded"
          width={50}
          height={50}
          animation="wave"
          sx={{ borderRadius: '6px', flexShrink: 0 }}
        />
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <Skeleton variant="text" width="50%" sx={{ fontSize: '12px' }} animation="wave" />
          <Skeleton variant="text" width="65%" sx={{ fontSize: '12px' }} animation="wave" />
        </Box>
        <Skeleton
          variant="rounded"
          width={130}
          height={36}
          animation="wave"
          sx={{ borderRadius: '6px', flexShrink: 0 }}
        />
      </Box>
    </CardContent>
  </StyledCard>
);
